import { useFetcher } from "~/hooks/useFetcher";

const { VITE_RWB_API } = import.meta.env;

type AccessLevel = "read" | "write";

const useFilePermissions = () => {
  return useFetcher<Record<string, AccessLevel[]>>(`${VITE_RWB_API}/file-browser/permissions`, {
    keepPreviousData: true,
  });
};

export default useFilePermissions;
